<template>
    <div class="sensor-chart-renderer">
        <apexchart
            ref="apexChart"
            :key="chartKey"
            width="100%"
            type="line"
            height="300px"
            :options="chartOptions"
            :series="series"
        ></apexchart>
    </div>
</template>

<script>
export default {
    name: 'ChartRenderer',
    props: {
        chartKey: {
            type: Number,
            default: 1
        },

        chartOptions: {
            type: Object,
            required: true
        },

        series: {
            type: Array,
            required: true
        }
    },
    methods: {
        getChartInstance() {
            const chartComponent = this.$refs.apexChart
            return chartComponent && chartComponent.chart ? chartComponent.chart : null
        },

        zoomX(min, max) {
            const chart = this.getChartInstance()

            if (chart && typeof chart.zoomX === 'function') {
                chart.zoomX(min, max)
                return true
            }

            return false
        }
    }
}
</script>

<style lang="scss" scoped>
.sensor-chart-renderer {
    width: 100%;
    touch-action: inherit;
    overscroll-behavior: contain;
}
</style>
